import Vue from 'vue';
import { msToast } from 'msComponents';
import { sleep, isTimeDifference } from './common';
import { msLocalStorage } from '@common/utils/cache';
import { queryAdeServiceInfoV2 } from '@/common/services/advertisements';
import { queryAdGroupInfo, queryVossAbResult, queryVossAbParam } from '@common/services/common';
import { getQueryString } from '@common/utils/common';

let config = null;
let showAb = true;
let popup = null;
let handleType = null;

// 支持绑定“返回”埋点上报的页面路径
var supportPaths = ['/loan'];

/**
 * 侧滑和点击返回
 */
function haneldeTypeFn(handleType) {
  if (handleType == '2') {
    return '滑动返回';
  } else if (handleType == '1') {
    return '点击返回';
  } else {
    return '';
  }
}

/**
 * 上报返回埋点
 */
function reportBackBtn() {
  window.REPORT_TRACK('AyhH5Click', {
    element_name: '返回',
    element_text: '返回',
    event_type: 'click',
    handle_type: haneldeTypeFn(handleType),
  });
}

/**
 * 返回按钮执行
 */
async function pageBackBtnCallback() {
  reportBackBtn();
  if (handleType == '2' && window.$stayDialogIsShow) {
    return;
  }
  window.AdReach.execCommand({ eventType: 0, eventValue: 'backPage' });
}

/**
 * 绑定页面“返回”按钮埋点事件
 */
async function onPageBackReportEvent() {
  if (supportPaths.includes(location.pathname)) {
    window.AdReach.onPageBackEvent(pageBackBtnCallback);
  }
}
/**
 * 解绑页面“返回”按钮埋点事件
 */
async function offPageBackReportEvent() {
  window.AdReach.offPageBackEvent(pageBackBtnCallback);
}

/**
 * 获取挽留弹窗配置信息，展示分流信息
 * @param {Object} param { abParams, abCode }
 * @returns {Promise} { config showAb }
 */
const initConfig = async ({ abParams, abCode }) => {
  if (config === null) {
    const p = [
      queryVossAbParam(
        { params: abParams },
        {
          ignoreError: true,
        },
      ),
    ];
    if (abCode) {
      // 分流到 A 组，不展示弹窗
      p.push(queryVossAbResult({ moduleCodes: abCode }, { errDialog: false, ignoreError: true }));
    }
    const [abParamsRes, abRes] = await Promise.all(p);
    try {
      config = new Function('return ' + abParamsRes[abParams])();
    } catch (e) {
      console.log(e);
    }
    abCode && (showAb = abRes?.[abCode]?.value !== 'A');
  }
  return { config, showAb };
};

//定制化挽留弹窗的入参 & 按钮监听事件，要定制化特殊处理的url
const CUSTOMIZE_URL_RULES = [
  {
    pattern: 'ncredit/apply/protocol',
    needWaitting: true,
    listener: () => {
      //adp监听事件
      window.AdReach.$eventBus.on('redirectCreditNextStepFe', (res) => {
        Vue.prototype.$EventBus.$emit('redirectCreditNextStepFe');
      });
    },
    handler: () => ({
      //传给adp的参数
      frontMap: {
        iframeUrl: `${location.origin}/ncredit/apply/protocolWanLiu${location.search}`,
      },
    }),
  },
  {
    pattern: 'ncredit/apply/identityInfo',
    listener: () => {
      //adp监听事件
      window.AdReach.$eventBus.on('nonRealName2CreaditProcess', (res) => {
        Vue.prototype.$EventBus.$emit('nonRealName2CreaditProcess');
      });
    },
    handler: () => {
      //传给adp的参数
      //二合一挽留弹窗定制样式
      const aliPayInstallStatus = msLocalStorage.get('aliPayInstallStatus');
      return getQueryString('shuntCode') === 'F50N10L50T10C10'
        ? {
            frontMap: {
              real_name_breakpoint_not_triggered: 1,
              alipay_install_status: aliPayInstallStatus,
            },
          }
        : {
            frontMap: {
              alipay_install_status: aliPayInstallStatus,
            },
          };
    },
  },
  {
    pattern: 'ncredit/apply/checkFace',
    listener: () => {
      //adp监听事件
      window.AdReach.$eventBus.on('agreeOcrAuthAgreementContinueFe', (res) => {
        Vue.prototype.$EventBus.$emit('agreeOcrAuthAgreementContinueFe');
      });
      window.AdReach.$eventBus.on('openProtocol', (res) => {
        Vue.prototype.$EventBus.$emit('openProtocol', res);
      });
    },
    handler: () => {
      //传给adp的参数
      const jiJian = localStorage.getItem('flowNo') == 'F53';
      const studentFlag = localStorage.getItem('studentFlag');
      const skipAuthCode = getQueryString('skipAuthCode');

      const credit_agreement_list = [
        {
          label: '活体识别授权协议',
          value: 5,
        },
      ];
      const jiJianList = [
        {
          label: '个人贷款申请及征信、信息授权协议',
          value: 1,
        },
        {
          label: '个人电子签名签署授权书',
          value: 2,
        },
        {
          label: '循环额度贷款合同',
          value: 3,
        },
      ];
      const steudentAgrement = [
        {
          label: '非学生承诺函',
          value: 4,
        },
      ];
      if (jiJian || skipAuthCode === '1') {
        credit_agreement_list.push(...jiJianList);
        if (studentFlag === '1') {
          credit_agreement_list.push(...steudentAgrement);
        }
      }
      return {
        variableMap: {
          '2.credit_agreement_list': JSON.stringify(credit_agreement_list),
        },
      };
    },
  },
  // 未来新增规则直接在此追加...
];

const customizeParams = () => {
  // 1. 使用find直接获取匹配规则和结果，避免重复遍历
  const matchedRule = CUSTOMIZE_URL_RULES.find((item) =>
    new RegExp(item.pattern).test(window.location.pathname),
  );
  return {
    currentTime: new Date(),
    ifMatchURL: !!matchedRule,
    adpParams: matchedRule?.handler() || {}, // 传给adp的参数
    listener: matchedRule?.listener || null,
    needWaitting: matchedRule?.needWaitting || false,
  };
};
/**
 * 初始化弹窗
 * @param {Object} param { abCode, tqCode, tqPageCode }
 * @returns
 */
const initDialog = async ({ abCode, tqCode, tqPageCode, tqSlotCode, test }) => {
  offPageBackReportEvent();
  const initCustomizeDate = customizeParams();
  window.AdReach?.onPageBackEvent(async (params) => {
    window.isSpecialAdpBanner = false;
    const backCustomizeDate = customizeParams();
    const isTimeDifference3s = isTimeDifference(
      initCustomizeDate.currentTime,
      backCustomizeDate.currentTime,
    );
    handleType = params?.backClickType;
    reportBackBtn();
    const p = tqSlotCode
      ? [
          queryAdeServiceInfoV2(
            tqSlotCode,
            customizeParams().ifMatchURL ? customizeParams().adpParams : {},
          ),
        ]
      : [queryAdGroupInfo({ pageCode: tqPageCode, adGroupCode: tqCode })];
    if (abCode) {
      // 广告分流
      p.push(queryVossAbResult({ moduleCodes: abCode }));
    }
    const [bannerRes, abRes] = await Promise.all(p);
    if (abCode && bannerRes?.[tqCode]?.tqAdInfoList?.length) {
      window.stayDialogIsShow = true;
      const abValue = abRes?.[abCode]?.value;
      bannerRes[tqCode].tqAdInfoList = bannerRes[tqCode].tqAdInfoList.filter((item) =>
        new RegExp(`model${abValue}`).test(item.adName),
      );
    }
    if (tqSlotCode && bannerRes?.adDetails?.length) {
      // 新天权广告
      onPageBackReportEvent();
      window.stayDialogIsShow = true;

      if (backCustomizeDate.ifMatchURL) {
        backCustomizeDate.listener?.();
        window.isSpecialAdpBanner =
          bannerRes.adDetails[0].extendedField === 'ApplyProtocolFloatLayer'; // 判断授信协议特殊adp-banner
        if (backCustomizeDate.needWaitting && isTimeDifference3s && window.isSpecialAdpBanner) {
          msToast.loading({
            message: '',
            duration: 3000,
          });
          await sleep(3000);
        }
      }
      popup = window.AdReach?.insertLayout(
        { adsFront: [bannerRes] },
        {
          onClickLeftButton() {
            window.stayDialogIsShow = false;
            offPageBackReportEvent();
            window.AdReach?.execCommand({ eventType: 0, eventValue: 'backPage' });
          },
          setupComponentOptions: {
            onClose: function () {
              window.stayDialogIsShow = false;
            },
            onOpen(data) {
              if (data && data.eventTrack) {
                msLocalStorage.set('TrackSlotCode', data?.eventTrack?.creative_name);
              }
            },
            onBeforeDestroy() {
              try {
                msLocalStorage.remove('TrackSlotCode');
              } catch (error) {
                console.error('清除本地存储失败:', error);
              }
            },
          },
        },
      );
      setFrequency(test);
      return;
    } else if (
      !bannerRes?.[tqCode]?.tqAdInfoList?.length ||
      !bannerRes?.[tqCode]?.tqAdInfoList?.[0]?.adStyleTemplateDto?.h5FileUrl
    ) {
      // 无广告，返回上一页
      window.AdReach.execCommand({ eventType: 0, eventValue: 'backPage' });
      return;
    }

    onPageBackReportEvent();
    // Popup 组件取 tqAdInfoList 第一个广告展示
    popup = new window.AdReach.components.Popup(bannerRes?.[tqCode], {
      width: '80%',
      animation: false,
      closeable: false,
      onShow() {
        const sensorsExposure = window.AdReach.sensors?.TQ?.sensorsExposure;
        sensorsExposure && sensorsExposure(this.data);
      },
      onClickLeftButton() {
        window.stayDialogIsShow = false;
        offPageBackReportEvent();
        window.AdReach.execCommand({ eventType: 0, eventValue: 'backPage' });
      },
    });
    popup.$mount();
    setFrequency(test);
  });
};

const setFrequency = (path) => {
  let stayDialogShowInfo = {}; // { showDate: '', test: frequency }
  try {
    stayDialogShowInfo = msLocalStorage.get('stayDialogShowInfo') || {};
  } catch (e) {
    console.log(e);
  }
  stayDialogShowInfo.showDate = new Date().toDateString();
  stayDialogShowInfo[path] = (Number(stayDialogShowInfo[path]) || 0) + 1;
  localStorage.setItem('stayDialogShowInfo', JSON.stringify(stayDialogShowInfo));
};

const faceBackHome = () => {
  // 获取当前URL的查询参数
  const urlParams = new URLSearchParams(window.location.search);

  // 检查是否存在faceNavigation参数,如果存在，则当前页面直接返回首页
  if (urlParams.has('faceNavigation')) {
    window.AdReach?.onPageBackEvent((params) => {
      window.AdReach?.execCommand({ eventType: 0, eventValue: 'backHome' });
    });
  }
};

/**
 * @param {String} abParams 挽留弹窗ab参数
 * @param {String} abCode 是否展示挽留弹窗ab分流，分流到 A 组，不展示弹窗，默认展示弹窗
 */
const initStay = async (route, abParams = 'stayRule', abCode = 'RetentionPopControl') => {
  onPageBackReportEvent();
  faceBackHome();
  const { query, path } = route || {};
  const { config, showAb } = await initConfig({ abParams, abCode });
  const noStay = !!Number(query.noStay);
  if (!config?.length || !showAb || noStay) return false;
  const pathReg = new RegExp(/^\/npublic\/addbank/);
  // item.test: /npublic/addbank?type=1
  const pageConfig = config.find((item) => item.test && new RegExp(item.test).test(path));
  if (!pageConfig || !pageConfig.showRule) return false;
  const { test, Frequency: frequency } = pageConfig;
  if (frequency) {
    // 判断次数缓存, 每日清空
    let stayDialogShowInfo = null; // { showDate: '', test: frequency }
    try {
      stayDialogShowInfo = msLocalStorage.get('stayDialogShowInfo');
    } catch (e) {
      console.log(e);
    }
    if (stayDialogShowInfo && stayDialogShowInfo.showDate !== new Date().toDateString()) {
      localStorage.removeItem('stayDialogShowInfo');
      stayDialogShowInfo = null;
    }
    if (!Number(frequency) || stayDialogShowInfo?.[test] >= frequency) return false;
  }
  initDialog(pageConfig);
};

const destoryStayPopup = () => {
  popup && popup.$destroy && popup.$destroy();
};

export { initStay, destoryStayPopup };
